import { useEffect } from "react";
import { useLocation } from "react-router-dom";

/**
 * Fires a Meta Pixel `PageView` on every React Router navigation.
 *
 * The base pixel snippet in `public/index.html` already fires PageView on
 * initial page load. This component handles subsequent SPA route changes
 * (clicks on <Link/>, browser back/forward, etc.) so Facebook Ads sees
 * every screen, not just the landing one.
 *
 * Renders nothing. Mount once inside <BrowserRouter> in App.js.
 */
export default function MetaPixelTracker() {
  const location = useLocation();

  useEffect(() => {
    if (typeof window === "undefined" || typeof window.fbq !== "function") return;
    try {
      window.fbq("track", "PageView");
    } catch (_e) {
      // never break the app for analytics
    }
  }, [location.pathname, location.search]);

  return null;
}
